// import logo from './logo.svg';
// import './App.css';
import Landing from './Pages/Landing/Landing';
import { Route, Routes } from 'react-router-dom';
import ProductOrder from './Pages/ProductOrder/ProductOrder';
import PaymentComponent from './Pages/Checkout/Checkout';
import { useState } from 'react';
import MobileMoneyPayment from './Pages/Pay/Pay';

import Tracker from "../src/Pages/Tracker/Tracker"
import AuthForm from './Pages/Auth/AuthForm';
import Dash from "../src/Pages/Dash/Dash"



// useState



function App() {

  const [cartItem,setCartItem] = useState([])

  const handleCart = (item,count) => {
    console.log("uplift dated", cartItem);
  
    setCartItem((prevCart) => {
      const updatedCart = [...prevCart, 

        {
          Price: item?.price,
          count: count,
          Name: item?.title,
          location: item?.location,
          ID: item?.id,

        },
          
      ];
      // const updatedCart = [...prevCart, item];
      console.log("uplift2", updatedCart);
      return updatedCart;
    });
  };




   
  return (

    <>    

<Routes>
                     {/* PUBLIC */}
                      <Route path="/" element={<Landing/>}>

                      </Route>

                      
                      {/* <Route path="/ProductOrder" element={<ProductOrder/>}>

                      </Route> */}

                      <Route path="/ProductOrder/:PID"  element={<ProductOrder handleCart={handleCart}/>}>

                      </Route>



                   
                      <Route path="/checkout" element={<PaymentComponent/>}>
                     

                      </Route> 
                      <Route path="/tracker" element={<Tracker/>}>
                     

                      </Route> 
                      <Route path="/auth" element={<AuthForm/>}>
                     
                       {/* jeae */}
                       {/* jeae */}

                      </Route> 
                      <Route path="/pay" element={<MobileMoneyPayment/>}>
                     

                      </Route> 
                      <Route path="/dash" element={<Dash/>}>
                     

                      </Route> 
                      {/* <Route path="/Recovery/:token" element={<Recovery/>}>
                     

                      </Route>  */}
         </Routes>


    </>
   
  );
}

export default App;
